<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Validasi</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'validasiBelumTercatat' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form class="needs-validation" @submit.prevent="submitForm">
          <b-form-row>
            <b-col md="10" offset-md="1">
              <b-form-group label="Kode Lokasi" label-for="kodeLokasi">
                <b-form-input id="kodeBarang" v-model="kodeLokasi" disabled />
              </b-form-group>

              <b-form-group label="KIB" label-for="kib">
                <b-form-input id="kib" v-model="kib" disabled />
              </b-form-group>

              <b-form-group label="Nama Barang" label-for="kodeBarang">
                <b-form-input id="kodeBarang" v-model="nabar" disabled />
              </b-form-group>

              <b-form-group label="Kode Barang" label-for="kodeBarang">
                <b-form-input id="kodeBarang" v-model="kodeBarang" disabled />
              </b-form-group>

              <b-form-group label="Nilai Perolehan" label-for="nilaiPerolehan">
                <b-form-input
                  id="nilaiPerolehan"
                  v-model="nilaiPerolehan"
                  disabled
                />

                <!-- <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                    <b-form-group
                                        label="Sumber"
                                        label-for="kodeRegisterBarang"
                                    >
                                        <b-form-input
                                            id="kodeRegisterBarang"
                                            v-model="kodeRegisterBarangVal"
                                            disabled
                                        />
                                    </b-form-group>
                                </b-col> -->
              </b-form-group>

              <b-form-group label="Cara Perolehan" label-for="caraPerolehan">
                <b-form-input
                  id="caraPerolehan"
                  v-model="caraPerolehan"
                  disabled
                />
              </b-form-group>

              <b-form-group
                label="Tanggal Perolehan"
                label-for="tanggalPerolehan"
              >
                <b-form-input
                  id="tanggalPerolehan"
                  v-model="tanggalPerolehan"
                  disabled
                />

                <!-- <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                                    <b-form-group
                                        label="Sumber"
                                        label-for="kodeRegisterBarang"
                                    >
                                        <b-form-input
                                            id="kodeRegisterBarang"
                                            v-model="kodeRegisterBarangVal"
                                            disabled
                                        />
                                    </b-form-group>
                                </b-col> -->
              </b-form-group>

              <b-form-group label="Dokumen" label-for="kodeRegisterBarang">
                <b-form-radio v-model="dokumenPendukung" value="1" disabled>
                  Ada
                </b-form-radio>
                <b-col
                  cols="11"
                  offset-md="1"
                  class="mt-1 pr-0"
                  v-if="dokumenPendukung === '1'"
                >
                  <b-form-group label="Sebutkan" label-for="dokumenPendukung">
                    <b-form-input
                      id="dokumenPendukung"
                      v-model="dokumenPendukungSebut"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-form-radio v-model="dokumenPendukung" value="0" disabled>
                  Tidak Ada
                </b-form-radio>
              </b-form-group>

              <b-form-group label="Kondisi Barang" label-for="kondisi">
                <b-form-input id="kondisi" v-model="kondisi" disabled />
              </b-form-group>

              <b-form-group label="Alamat" label-for="kodeRegisterBarang">
                <b-col cols="11" offset-md="1" class="mt-1 pr-0">
                  <b-form-group label="Provinsi" label-for="provinsi">
                    <b-form-select
                      id="provinsi"
                      v-model="provinsi"
                      :options="dataProvinsi"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group label="Kabupaten/Kota" label-for="kabKota">
                    <b-form-select
                      id="kabKota"
                      v-model="kabKota"
                      :options="dataKabKota"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group label="Kecamatan" label-for="kecamatan">
                    <b-form-select
                      id="kecamatan"
                      v-model="kecamatan"
                      :options="dataKecamatan"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group label="Kelurahan" label-for="kelurahan">
                    <b-form-select
                      id="kelurahan"
                      v-model="kelurahan"
                      :options="dataKelurahan"
                      disabled
                    />
                  </b-form-group>

                  <b-form-group label="Jalan" label-for="jalan">
                    <b-form-input id="jalan" v-model="jalan" disabled />
                  </b-form-group>

                  <b-row>
                    <b-col cols="2">
                      <b-form-group label="No" label-for="noAlamat">
                        <b-form-input
                          id="noAlamat"
                          v-model="noAlamat"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="2">
                      <b-form-group label="RT" label-for="rt">
                        <b-form-input id="rt" v-model="rt" disabled />
                      </b-form-group>
                    </b-col>
                    <b-col cols="2">
                      <b-form-group label="RW" label-for="rw">
                        <b-form-input id="rw" v-model="rw" disabled />
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group label="Kode Pos" label-for="kodePos">
                        <b-form-input id="kodePos" v-model="kodePos" disabled />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="Keterangan" label-for="keterangan">
                <b-form-input id="keterangan" v-model="keterangan" disabled />
              </b-form-group>

              <b-form-group label="Foto" v-if="foto">
                <b-img
                  class="mx-auto"
                  :src="foto"
                  fluid
                  style="max-height: 300px"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card no-body v-if="$can('Validasi', 'validasiBelumTercatat')">
      <b-card-header>
        <b-card-title>Verifikasi P3B</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form class="needs-validation" @submit.prevent="submitForm">
          <b-form-row>
            <b-col md="10" offset-md="1">
              <b-form-group
                label="Status Persetujuan"
                label-for="statusPersetujuan"
              >
                <b-row>
                  <b-col md="3">
                    <b-form-radio v-model="statusPersetujuan" value="1">
                      Setuju
                    </b-form-radio>
                  </b-col>
                  <b-col>
                    <b-form-radio v-model="statusPersetujuan" value="0">
                      Tidak Setuju
                    </b-form-radio>
                  </b-col>
                </b-row>
                <small
                  class="text-danger"
                  v-for="(error, index) of v$.statusPersetujuan.$errors"
                  :key="index"
                >
                  <span>{{ error.$message }}</span>
                </small>
              </b-form-group>

              <b-form-group
                label="Catatan"
                label-for="catatan"
                v-if="statusPersetujuan === '0'"
              >
                <b-form-textarea
                  id="catatan"
                  v-model="v$.catatan.$model"
                  :state="validateState(v$.catatan)"
                />
                <b-form-invalid-feedback
                  v-for="(error, index) of v$.catatan.$errors"
                  :key="index"
                >
                  <span v-if="error.$validator == 'checkCatatan'"
                    >Catatan Harus di Isi Jika Tidak Setuju</span
                  >
                  <span v-else>{{ error.$message }}</span>
                </b-form-invalid-feedback>
              </b-form-group>
              <b-col cols="12" class="text-right pr-0 pt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                >
                  <div v-if="isSubmit">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div v-else>Validasi</div>
                </b-button>
              </b-col>
            </b-col>
          </b-form-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
  BTable,
  BRow,
  BFormTextarea,
} from "bootstrap-vue";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { ref, computed, watchEffect } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { intThousand } from "@/libs/helper";
const moment = require("moment");
import validasiKeberadaan from "@/composables/validasiKeberadaan";
import validasiBelumTercatat from "@/composables/validasiBelumTercatat";
import master from "@/composables/master";

export default {
  props: {
    action: String,
    id: String,
  },
  setup(props, context) {
    const g = context.root;

    var isSubmit = ref(false);
    const router = g.$router;
    const $http = g.$http;

    let isShowUbah = ref(false);

    //form name
    var kodeLokasi = ref("");
    var kib = ref("");
    var kodeBarang = ref("");
    var nabar = ref("");
    var kodeRegisterBarang = ref("");
    var nilaiPerolehan = ref("");
    var tanggalPerolehan = ref("");
    var caraPerolehan = ref("");
    var dokumenPendukung = ref("");
    var dokumenPendukungSebut = ref("");
    var kondisi = ref("");
    var provinsi = ref(null);
    var kabKota = ref(null);
    var kecamatan = ref(null);
    var kelurahan = ref(null);
    var jalan = ref("");
    var noAlamat = ref("");
    var rt = ref("");
    var rw = ref("");
    var kodePos = ref("");
    var keterangan = ref("");
    var foto = ref("");

    var catatan = ref("");
    var statusPersetujuan = ref(null);

    var dataKodeLokasi = ref([]);
    var dataKib = ref([]);
    var dataKabKota = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);
    var dataKecamatan = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);
    var dataKelurahan = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);
    var dataProvinsi = ref([{ value: null, text: "-- Pilih Salah Satu --" }]);

    watchEffect(() => {});

    const getKabKota = async () => {
      let params = {
        provinsi: provinsi.value,
      };
      let resKota = await master.getKota(g, params);
      resKota.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataKabKota.value = resKota;
    };

    const getKecamatan = async () => {
      let params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
      };
      let resKecamatan = await master.getKecamatan(g, params);
      resKecamatan.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataKecamatan.value = resKecamatan;
    };

    const getKelurahan = async () => {
      let params = {
        provinsi: provinsi.value,
        kota: kabKota.value,
        kecamatan: kecamatan.value,
      };
      let resKelurahan = await master.getKelurahan(g, params);
      resKelurahan.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataKelurahan.value = resKelurahan;
    };

    const getProvinsi = async () => {
      let resProvinsi = await master.getProvinsi(g);
      resProvinsi.unshift({ text: "-- Pilih Salah Satu --", value: null });
      dataProvinsi.value = resProvinsi;
    };

    const getData = async () => {
      const response = await validasiKeberadaan.getBmdDetail(g, {
        id: props.id,
        username: g.$cookies.get("username"),
      });
      const { data, code } = response;

      if (code == 200) {
        const {
          KOLOK,
          nama_pd_ukpd_siera,
          kib: kibVal,
          kobar_108,
          nabar_108,
          noreg_108,
          HARGA,
          TGLOLEH,
          NM_ASALOLEH_UNFOUND,
          dokumen_pendukung,
          dokumen_pendukung_note,
          nm_kondisi,
          UKURAN,
          BETON,
          ALAMAT,
          rekon_kode,
          rekon_tahun,
          status,
          di_validasi_sensus_note,
          di_m_kobar,
          di_m_kobar_a,
          di_m_nabar_a,
          di_m_ukuran,
          di_m_ukuran_a,
          di_cara_perolehan,
          di_m_bertingkat,
          di_m_bertingkat_a,
          di_m_lantai_tdk,
          di_m_lantai_tdk_all,
          di_m_lantai_tdk_use,
          di_m_lantai_tdk_not,
          di_m_beton,
          di_m_beton_a,
          di_m_sk_penggunaan,
          di_sk_penggunaan_tahun,
          di_sk_penggunaan_no,
          di_penggunaan,
          penggunaan_pihak_lain,
          penggunaan_opd,
          di_gedung_bangunan_diatas_tanah_milik,
          di_gedung_bangunan_diatas_tanah_milik_sebut,
          di_m_alamat,
          kd_prop,
          kd_rayon,
          kd_kec,
          kd_kel,
          KD_POS,
          jalan: jalanVal,
          nojalan,
          rt: rtVal,
          rw: rwVal,
          keterangan_bmd_belum_ditemukan,
          di_indikasi_ganda,
          di_indikasi_ganda_dengan,
          di_indikasi_ganda_sebutkan,
          di_indikasi_ganda_opd,
          di_indikasi_ganda_kobar,
          di_indikasi_ganda_register,
          di_m_kobar_kib,
          di_gedung_bangunan_diatas_tanah_milik_opd,
          di_gedung_bangunan_diatas_tanah_milik_kobar,
          di_gedung_bangunan_diatas_tanah_milik_noreg,
          bmd_belum_ditemukan_dok,
        } = data;

        kodeLokasi.value =
          KOLOK + (nama_pd_ukpd_siera ? "::" + nama_pd_ukpd_siera : "");
        kib.value = kibVal;
        kodeBarang.value = kobar_108;
        kodeRegisterBarang.value = noreg_108;
        nabar.value = nabar_108;
        nilaiPerolehan.value = intThousand(HARGA.toString().replace(".", ","));
        tanggalPerolehan.value = TGLOLEH;
        caraPerolehan.value = NM_ASALOLEH_UNFOUND;
        dokumenPendukung.value = dokumen_pendukung;
        dokumenPendukungSebut.value = dokumen_pendukung_note;
        kondisi.value = nm_kondisi;
        provinsi.value = kd_prop;
        kabKota.value = kd_rayon;
        kecamatan.value = kd_kec;
        kelurahan.value = kd_kel;
        jalan.value = jalanVal;
        noAlamat.value = nojalan;
        rt.value = rtVal;
        rw.value = rwVal;
        kodePos.value = KD_POS;
        keterangan.value = keterangan_bmd_belum_ditemukan;
        foto.value = bmd_belum_ditemukan_dok;

        statusPersetujuan.value =
          status == 11 ? "0" : status == 12 ? "1" : null;
        // catatan.value = di_validasi_sensus_note

        getProvinsi();
        getKabKota();
        getKecamatan();
        getKelurahan();
      }

      isShowUbah.value = false;
    };

    getData();

    const checkCatatan = (val) => {
      if (!val && statusPersetujuan.value == 0) return false;

      return true;
    };

    // validation
    const requiredMsg = "tidak boleh kosong";
    const $externalResults = ref({});
    const rules = computed(() => ({
      statusPersetujuan: {
        required: helpers.withMessage(
          "Status Persetujuan " + requiredMsg,
          required
        ),
      },
      catatan: {
        checkCatatan,
      },
    }));

    const v$ = useVuelidate(
      rules,
      { statusPersetujuan, catatan },
      { $externalResults, $autoDirty: true }
    );

    const submitForm = async () => {
      isSubmit.value = true;
      const isFormCorrect = await v$.value.$validate();
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      //jika error validasi

      if (!isFormCorrect) {
        isSubmit.value = false;
        return;
      }

      // mapping data
      let data = {
        unfound_validasi_sensus: statusPersetujuan.value,
        unfound_validasi_sensus_note: catatan.value,
        id_emp: g.$cookies.get("username"),
        id: props.id,
      };

      await validasiBelumTercatat.validasi(g, data);
      isSubmit.value = false;
    };

    const validateState = (item) => {
      const { $dirty, $error } = item;
      return !$dirty ? null : $error ? false : null;
    };

    const resetForm = () => {};

    return {
      v$,
      $externalResults,
      isSubmit,
      kodeLokasi,
      kib,
      kodeBarang,
      nabar,
      kodeRegisterBarang,
      nilaiPerolehan,
      tanggalPerolehan,
      dokumenPendukung,
      dokumenPendukungSebut,
      caraPerolehan,
      kondisi,
      catatan,
      statusPersetujuan,
      provinsi,
      kabKota,
      kecamatan,
      kelurahan,
      jalan,
      noAlamat,
      rt,
      rw,
      kodePos,
      keterangan,
      foto,
      dataKodeLokasi,
      dataKib,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      resetForm,
      validateState,
      submitForm,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
    BTable,
    BRow,
    BFormTextarea,
  },
};
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>